const tiersColor = {
  bronze: 'linear-gradient(153deg, #F9F1DD 3.33%, #FDFAF2 96.55%)',
  silver: 'linear-gradient(124deg, #CCC8C5 -21.2%, #F3F3F1 97.19%)',
  gold: 'linear-gradient(140deg, #C0AB9A -31.62%, #ECE2D9 28.17%, #FAF3ED 126%)',
  eip: 'linear-gradient(304deg, #9B825C -2.2%, #6B492A 85.03%)',
  eipplatinum: 'linear-gradient(311deg, #ACA59D -25.42%, #7D6E64 31.48%, #43444A 91.91%)',
}

export default {
  tiersColor,
}